import styled from 'styled-components'

const StyledCheckoutView = styled.div`
  min-height: 100dvh;
  background-color: ${({ theme }) => theme.color.gray[100]};
`

export default StyledCheckoutView
